"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLUGIN_SETTING_TYPE = void 0;
const IS_ACTIVE = 'IS_ACTIVE';
exports.PLUGIN_SETTING_TYPE = {
    IS_ACTIVE
};
//# sourceMappingURL=pluginSettingType.js.map